import { ref, onMounted } from 'vue'
import axios from 'axios'

// Composable to get the current package version
export function useVersion() {
  const version = ref('1.0.0')
  const loading = ref(true)
  const error = ref(false)

  // Load version from package.json
  onMounted(async () => {
    try {
      loading.value = true
      const response = await axios.get('/package.json', {
        // Add cache-busting parameter to prevent caching issues
        params: { _t: new Date().getTime() }
      })
      version.value = response.data.version || '1.0.0'
    } catch (err) {
      console.error('Failed to load version:', err)
      error.value = true
      // Version is already set to default '1.0.0'
    } finally {
      loading.value = false
    }
  })

  return {
    version,
    loading,
    error
  }
}